export default function Instagram() {
  return (
    <a target="_blank" href="https://instagram.com/hashguys.nft" rel="noreferrer">
      <img
        src="/assets/icons/instagram.svg"
        alt="Hashguys instagram link"
        className="lg:h-[36px] lg:w-[36px] h-[14px] w-[14px]"
      />
    </a>
  )
}